import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../axios";
import { StatisticDataType } from "@/common/types";

const periodType = ["day", "week", "month", "year"] as const;
type PeriodType = (typeof periodType)[number];

const getQuoteStatistic = async (periodType: PeriodType) => {
  const params = new URLSearchParams({ periodType });
  return await axiosInstance
    .get("quotes/statistic", { params })
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};

const useGetQuoteStatistic = (periodType: PeriodType) => {
  return useQuery<StatisticDataType>({
    queryKey: ["quoteStatistic", periodType],
    queryFn: () => getQuoteStatistic(periodType),
  });
};

export default useGetQuoteStatistic;
